import React from 'react';
import {
	Toast,
	ToastHeader,
	ToastImg,
	ToastInnerContainer,
	ToastTextContainer,
	ToastTitle,
} from '../../../TrailPage/Navigate/Toast/toastStyles';
// import { checkImage } from '../../../../componentUtils';
import { Trail } from '../../../../models/Trail';
import { checkImage } from '../../../componentUtils';
import { useAppSelector } from '../../../../state/hooks';
import { RootState } from '../../../../state/store';
import { shallowEqual } from 'react-redux';
import LoadingImage from '../../../Global/LoadingImage/LoadingImage';
import { generateTrailMetaString } from '../../../newComponentUtils';
import { useHistory } from 'react-router';

type SingleToastProps = {
	margin?: string;
	trail: Trail;
	onSelect?: () => void;
};
const SingleToast: React.FC<SingleToastProps> = ({
	margin,
	trail,
	onSelect,
}) => {
	const network_status = useAppSelector(
		(state: RootState) => state.network.status,
		shallowEqual,
	);
	const history = useHistory();

	const goToTrail = () => {
		if (onSelect) {
			onSelect();
		}
		history.push('/trail/' + trail.id);
	};

	return (
		<Toast margin={margin} onClick={goToTrail}>
			<ToastInnerContainer>
				{network_status && (
					<ToastImg>
						<LoadingImage src={checkImage(trail.image)} />
					</ToastImg>
				)}
				<ToastTextContainer className={network_status ? '' : 'offline'}>
					<ToastTitle>{trail.title}</ToastTitle>
					<ToastHeader>{generateTrailMetaString(trail)}</ToastHeader>
					{/* <ToastCaption>
						A Toast is a subtle notification commonly used in modern
						applications. It can be used to provide feedback about
						an operation or to display a system message.
					</ToastCaption> */}
				</ToastTextContainer>
			</ToastInnerContainer>
		</Toast>
	);
};

export default SingleToast;
